export * from './konstantes-list.component';
export * from './konstantes-list.component.module';